
import React, { createContext, useContext, useState } from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  const addToCart = (product) => {
    setCartItems((prevCartItems) => {
      const existingItem = prevCartItems.find(
        (item) => 
          item.id === product.id && 
          item.size === product.size && 
          item.color === product.color
      );

      if (existingItem) {
        // Update quantity if the item with the same size and color exists
        return prevCartItems.map((item) =>
          item.id === product.id && item.size === product.size && item.color === product.color
            ? { ...item, quantity: item.quantity + product.quantity }
            : item
        );
      } else {
        // Add the new item with size and color
        return [...prevCartItems, { ...product, quantity: product.quantity }];
      }
    });
  };

  const removeFromCart = (id, color, size) => {
    setCartItems((prevCartItems) =>
      prevCartItems.filter(
        (item) => item.id !== id || item.color !== color || item.size !== size
      )
    );
  };
  

  // const removeFromCart = (itemId, size, color) => {
  //   setCartItems((prevCartItems) =>
  //     prevCartItems.filter(
  //       (item) => !(item.id === itemId && item.size === size && item.color === color)
  //     )
  //   );
  // };

  const getTotalPrice = () => {
    return cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  return (
    <CartContext.Provider value={{ cartItems, addToCart, getTotalPrice, removeFromCart }}>
      {children}
    </CartContext.Provider>
  );
};


// import React, { createContext, useContext, useState } from "react";

// const CartContext = createContext();

// export const useCart = () => useContext(CartContext);

// export const CartProvider = ({ children }) => {
//   const [cartItems, setCartItems] = useState([]);

//   // const addToCart = (product) => {
//   //   setCartItems((prevCartItems) => {
//   //     const existingItem = prevCartItems.find((item) => item.id === product.id);
//   //     if (existingItem) {
//   //       return prevCartItems.map((item) =>
//   //         item.id === product.id
//   //           ? { ...item, quantity: item.quantity + 1 }
//   //           : item
//   //       );
//   //     } else {
//   //       return [...prevCartItems, { ...product, quantity: 1 }];
//   //     }
//   //   });
//   // };

//   const addToCart = (product) => {
//     setCartItems((prevCartItems) => {
//       const existingItem = prevCartItems.find((item) => item.id === product.id);
  
//       if (existingItem) {
//         return prevCartItems.map((item) =>
//           item.id === product.id
//             ? { ...item, quantity: item.quantity + product.quantity } // Add the selected quantity
//             : item
//         );
//       } else {
//         return [...prevCartItems, { ...product, quantity: product.quantity }]; // Add the new item with selected quantity
//       }
//     });
//   };
  

//   const removeFromCart = (itemId) => {
//     setCartItems((prevCartItems) =>
//       prevCartItems.filter((item) => item.id !== itemId)
//     );
//   };
  

//   // const getTotalPrice = () => {
//   //   return cartItems.reduce((total, item) => total + item.price * item.count, 0);
//   // };

//   // const getTotalPrice = () => {
//   //   return cartItems.reduce((total, item) => {
//   //     const itemTotal = Number(item.totalPrice); // Ensure totalPrice is a number
//   //     return total + itemTotal;
//   //   }, 0);
//   // };
  
//   const getTotalPrice = () => {
//     return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
//   };
  

//   return (
//     <CartContext.Provider value={{ cartItems, addToCart,getTotalPrice,removeFromCart }}>
//       {children}
//     </CartContext.Provider>
//   );
// };
